import { LocaleType } from './Locale';

const theLocale: LocaleType = {
    locale: 'br',
    alia: 'br',
    region: 'Brazil',
    regionText: 'brasil',
    language: 'Portuguese',
    languageText: 'Português',
    appId: 18,
    acceptLanguage: 'pt-BR,pt;q=0.9',
};
export default theLocale;
